const toCents = value => Math.round((Number(value) || 0) * 100);

export const sumCapitalAmounts = rows => {
  const totals = rows.reduce((result, row) => ({
    committedCents: result.committedCents + toCents(row.committed),
    calledCents: result.calledCents + toCents(row.called),
    uncalledCents: result.uncalledCents + toCents(
      row.uncalled ?? Number(row.committed) - Number(row.called)
    )
  }), { committedCents: 0, calledCents: 0, uncalledCents: 0 });

  return {
    committed: totals.committedCents / 100,
    called: totals.calledCents / 100,
    uncalled: totals.uncalledCents / 100
  };
};

export const capitalPositionGroupKey = position => {
  const investorId = position.investorId ?? position.investor_id;
  return investorId === null || investorId === undefined
    ? `position:${position.id}`
    : `investor:${investorId}`;
};

export const groupCapitalPositions = positions => {
  const groups = new Map();

  positions.forEach(position => {
    const key = capitalPositionGroupKey(position);
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        investorId: position.investorId ?? position.investor_id,
        investorName: position.investorName,
        investorEmail: position.investorEmail || (!position.appliedByDelegate ? position.email : ""),
        positions: [],
        committedCents: 0,
        calledCents: 0,
        uncalledCents: 0,
        searchValues: []
      });
    }

    const group = groups.get(key);
    group.positions.push(position);
    group.committedCents += toCents(position.committed);
    group.calledCents += toCents(position.called);
    group.uncalledCents += toCents(
      position.uncalled ?? Number(position.committed) - Number(position.called)
    );
    group.searchValues.push(
      position.investorName,
      position.investorEmail,
      position.email,
      position.ownershipDisplayName,
      position.delegateName,
      position.delegateEmail
    );
  });

  return Array.from(groups.values()).map(group => ({
    ...group,
    ...sumCapitalAmounts(group.positions),
    searchableText: group.searchValues.filter(Boolean).join(" ").toLowerCase()
  }));
};
